import React, {useEffect, useRef } from 'react';
import Utils from '../utils';

function NpcResult({ item, index, term}) {
    const componentRef = useRef(null);
    
    useEffect(() => {
        // Run doCH for the current component only
        if (componentRef.current) {
          Utils.highlightSearchTerm(componentRef.current, term);
          Utils.doCH(componentRef.current);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []); // Empty dependency array ensures this runs only once after initial render

  return (
    <li className={`result-item ${item.outputLanguage2 ? `multi` : ``}`} data-id={item.id} key={index} ref={componentRef}>
        <ul className="info-container" data-id={item.id}>
            <li>
                <span>{item.id}</span>
            </li>
        </ul>
        <ul className="language-container" data-id={item.id}>
            <li>
                <center>
                {item.inputLanguage.nick ? (
                <><span data-id={2} className="highlightable" style={{color: `#${item.inputLanguage.nickColor}`}}>{item.inputLanguage.nick}</span><br /><br /></>) : null}
                <strong>
                <span data-id={1} className={`item-name class-1 highlightable`}>{item.inputLanguage.name}</span>
                </strong>
                </center>
            </li>
        </ul>
        <ul className="language-container" data-id={item.id}>
            <li>
                <center>
                {item.outputLanguage.nick ? (
                <><span data-id={2} className="highlightable" style={{color: `#${item.outputLanguage.nickColor}`}}>{item.outputLanguage.nick}</span><br /><br /></>) : null}
                <strong>
                <span data-id={1} className={`item-name class-1 highlightable`}>{item.outputLanguage.name}</span>
                </strong>
                </center>
            </li>
        </ul>
        {/* Check if item has outputLanguage2 */}
        {item.outputLanguage2 ? (
            <ul className="language-container" data-id={item.id}>
            <li>
                <center>
                {item.outputLanguage2.nick ? (
                <><span data-id={2} className="highlightable" style={{color: `#${item.outputLanguage2.nickColor}`}}>{item.outputLanguage2.nick}</span><br /><br /></>) : null}
                <strong>
                <span data-id={1} className={`item-name class-1 highlightable`}>{item.outputLanguage2.name}</span>
                </strong>
                </center>
            </li>
        </ul>
        ): null}
    </li>
  );
}

export default NpcResult;